import styled from 'styled-components';

export const HeaderArea = styled.header`
  background-color: #fff;
  height: 60px;
  border-bottom: 1px solid #ccc;
  
  .container {
    max-width: 1700px;
    margin: auto;
    padding: 0 20px;
    display: flex;
    align-items: center;
    height: 100%;
  };

  a {
    text-decoration: none;
  };

  .logo {
    flex: 1;
    display: flex;
    align-items: center;
    
    a {
      display: flex;
      align-items: center;
      gap: 0;
    };

    img {
      display: block;
    };

    .logo-2 {
      font-size: 40px;
      font-weight: bold;
      color: green;
      line-height: 1;
    };

    .logo-3 {
      font-size: 10px;
      font-weight: bold;
      color: rgb(242, 128, 0);
      margin-left: 20px;
      align-self: center;
    };
  };

  nav {
    ul, li {
      margin: 0;
      padding: 0;
      list-style: none;
    };

    ul {
      display: flex;
      align-items: center;
      gap: 8px;
    };

    li {
      a, button {
        border: 0;
        background: none;
        cursor: pointer;
        outline: 0;
        color: #000;
        font-size: 14px;
        font-weight: 500;
        padding: 8px 16px;
        border-radius: 8px;
        transition: all 0.3s ease;
        display: inline-flex;
        align-items: center;
        gap: 6px;

        i {
          font-size: 14px;
        };

        &:hover {
          color: #999;
        };

        &.button {
          background-color: rgb(242, 128, 0);
          border-radius: 4px;
          color: #fff;
          padding: 8px 16px;
          transition: all 0.2s ease-in-out 0s;

          &:hover {
            background-color: #e57706;
          };
        };
      };
    };
  };

  .language-selector {
    display: flex;
    gap: 4px;
    margin-left: 20px;

    button {
      background: #f0f0f0;
      border: 1px solid #ddd;
      color: #333;
      padding: 6px 12px;
      border-radius: 6px;
      cursor: pointer;
      font-size: 12px;
      font-weight: 600;
      transition: all 0.3s ease;

      &:hover {
        background: #e0e0e0;
      };

      &.active {
        background: green;
        color: #fff;
        border-color: green;
      };
    };
  };

  .hamburger {
    display: none;
    flex-direction: column;
    justify-content: space-around;
    width: 30px;
    height: 25px;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    z-index: 10;

    span {
      width: 30px;
      height: 3px;
      background: #333;
      border-radius: 3px;
      transition: all 0.3s ease;
      transform-origin: 1px;

      &:nth-child(1).open {
        transform: rotate(45deg);
      }

      &:nth-child(2).open {
        opacity: 0;
      }

      &:nth-child(3).open {
        transform: rotate(-45deg);
      }
    }
  }

  @media (max-width: 768px){
    height: 60px;
    padding: 0;

    .container {
      flex-direction: row;
      justify-content: space-between;
      gap: 0;
      position: relative;
    };

    .logo {
      margin-top: 0;
      width: auto;
      justify-content: flex-start;

      .logo-3 {
        display: none;
      }

      .logo-2 {
        font-size: 28px;
      }

      img {
        height: 32px;
      }
    };

    .hamburger {
      display: flex;
    }

    nav {
      position: fixed;
      top: 60px;
      left: 0;
      right: 0;
      background: #fff;
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.3s ease;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      z-index: 999;

      &.mobile-open {
        max-height: 500px;
        border-bottom: 1px solid #ccc;
      }

      ul {
        flex-direction: column;
        padding: 20px;
        gap: 0;
      }

      li {
        width: 100%;
        text-align: center;
        margin: 0;
        border-bottom: 1px solid #eee;

        &:last-child {
          border-bottom: none;
        }

        a, button {
          width: 100%;
          justify-content: center;
          padding: 15px;
          font-size: 16px;

          &.button {
            margin-top: 10px;
          }
        }
      }
    };

    .language-selector {
      margin-left: 10px;
      gap: 2px;

      button {
        padding: 4px 8px;
        font-size: 11px;
      }
    };
  };
`;